import { Trans } from 'react-i18next';

import { PromiseVoidFunction } from '@dreryk/react-common';
import {
   Link,
   LinkSize,
   MarginPosition,
   Notification,
   NotificationSize,
   NotificationType,
} from '@dreryk/react-components';

import { downloadPersonalDataFromEwusTranslationKeys } from '../../../translations';

type EwusFetchErrorNotificationProps = {
   readonly onTryAgainClick: PromiseVoidFunction;
};

export const EwusFetchErrorNotification = (props: EwusFetchErrorNotificationProps): JSX.Element => {
   return (
      <Notification
         testId={'ewusFetchError'}
         margin={MarginPosition.TOP}
         size={NotificationSize.SMALLER}
         type={NotificationType.INFO}
         label={
            <Trans
               i18nKey={downloadPersonalDataFromEwusTranslationKeys.ewusConfigurationFetchError}
               components={{
                  tryAgainLink: (
                     <Link
                        testId={'ewusConfigurationTryAgain'}
                        label={downloadPersonalDataFromEwusTranslationKeys.tryAgain}
                        onClick={props.onTryAgainClick}
                        size={LinkSize.SMALL}
                        block={false}
                     />
                  ),
               }}
            />
         }
      />
   );
};
